import React from 'react';
import { LineItem } from '../types';

export interface ItemsPreviewCellProps {
  items: LineItem[];
}

export const ItemsPreviewCell: React.FC<ItemsPreviewCellProps> = ({ items }) => {
  if (!items.length) {
    return null;
  }

  const [first, ...rest] = items;

  return (
    <span className="sui-inline-flex sui-items-center sui-gap-2 sui-text-sm sui-text-primary">
      {first.imageUrl && (
        <img
          src={first.imageUrl}
          alt=""
          className="sui-h-10 sui-w-10 sui-rounded-base sui-border-1 sui-border-solid sui-border-primary sui-object-cover"
        />
      )}
      <span>
        {first.name}
        {rest.length ? ` + ${rest.length} more item${rest.length > 1 ? 's' : ''}` : ''}
      </span>
    </span>
  );
};
